import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { user, signingOut } = useAuth();
  if (user === null || (user === false && signingOut))
    return (
      <div className="min-h-screen grid place-items-center bg-[#050A15]">
        <Loader2 className="h-8 w-8 animate-spin text-[#00FFFF]" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};
